import React from 'react';
type AdvisorsSvgProps = {
  stroke: string;
};

export const FixedDepositSvg: React.FC<AdvisorsSvgProps> = props => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.125 6.9875V5.6875C7.52444 5.80998 6.97316 6.10636 6.53976 6.53976C6.10636 6.97316 5.80998 7.52444 5.6875 8.125H6.9875C7.08082 7.86288 7.23132 7.62481 7.42806 7.42806C7.62481 7.23132 7.86288 7.08082 8.125 6.9875Z"
      fill={props.stroke}
    />
    <path
      d="M6.9875 9.375H5.6875C5.80998 9.97556 6.10636 10.5268 6.53976 10.9602C6.97316 11.3936 7.52444 11.69 8.125 11.8125V10.5125C7.86288 10.4192 7.62481 10.2687 7.42806 10.0719C7.23132 9.87519 7.08082 9.63712 6.9875 9.375Z"
      fill={props.stroke}
    />
    <path
      d="M8.75 9.375C9.09518 9.375 9.375 9.09518 9.375 8.75C9.375 8.40482 9.09518 8.125 8.75 8.125C8.40482 8.125 8.125 8.40482 8.125 8.75C8.125 9.09518 8.40482 9.375 8.75 9.375Z"
      fill={props.stroke}
    />
    <path
      d="M9.375 10.5125V11.8125C9.97556 11.69 10.5268 11.3936 10.9602 10.9602C11.3936 10.5268 11.69 9.97556 11.8125 9.375H10.5125C10.4192 9.63712 10.2687 9.87519 10.0719 10.0719C9.87519 10.2687 9.63712 10.4192 9.375 10.5125Z"
      fill={props.stroke}
    />
    <path
      d="M9.375 5.6875V6.9875C9.63712 7.08082 9.87519 7.23132 10.0719 7.42806C10.2687 7.62481 10.4192 7.86288 10.5125 8.125H11.8125C11.69 7.52444 11.3936 6.97316 10.9602 6.53976C10.5268 6.10636 9.97556 5.80998 9.375 5.6875Z"
      fill={props.stroke}
    />
    <path
      d="M16.875 1.25H3.125C2.62772 1.25 2.15081 1.44754 1.79917 1.79917C1.44754 2.15081 1.25 2.62772 1.25 3.125V14.375C1.25 14.8723 1.44754 15.3492 1.79917 15.7008C2.15081 16.0525 2.62772 16.25 3.125 16.25H16.875C17.3723 16.25 17.8492 16.0525 18.2008 15.7008C18.5525 15.3492 18.75 14.8723 18.75 14.375V3.125C18.75 2.62772 18.5525 2.15081 18.2008 1.79917C17.8492 1.44754 17.3723 1.25 16.875 1.25ZM8.75 13.125C7.88471 13.125 7.03885 12.8684 6.31938 12.3877C5.59992 11.9069 5.03916 11.2237 4.70803 10.4242C4.37689 9.62481 4.29025 8.74515 4.45906 7.89648C4.62787 7.04781 5.04455 6.26826 5.65641 5.65641C6.26826 5.04455 7.04781 4.62787 7.89648 4.45906C8.74515 4.29025 9.62481 4.37689 10.4242 4.70803C11.2237 5.03916 11.9069 5.59992 12.3877 6.31938C12.8684 7.03885 13.125 7.88471 13.125 8.75C13.125 9.91032 12.6641 11.0231 11.8436 11.8436C11.0231 12.6641 9.91032 13.125 8.75 13.125ZM16.25 13.125C16.25 13.2908 16.1842 13.4497 16.0669 13.5669C15.9497 13.6842 15.7908 13.75 15.625 13.75C15.4592 13.75 15.3003 13.6842 15.1831 13.5669C15.0658 13.4497 15 13.2908 15 13.125V11.25C15 11.0842 15.0658 10.9253 15.1831 10.8081C15.3003 10.6908 15.4592 10.625 15.625 10.625C15.7908 10.625 15.9497 10.6908 16.0669 10.8081C16.1842 10.9253 16.25 11.0842 16.25 11.25V13.125ZM16.25 6.25C16.25 6.41576 16.1842 6.57473 16.0669 6.69194C15.9497 6.80915 15.7908 6.875 15.625 6.875C15.4592 6.875 15.3003 6.80915 15.1831 6.69194C15.0658 6.57473 15 6.41576 15 6.25V4.375C15 4.20924 15.0658 4.05027 15.1831 3.93306C15.3003 3.81585 15.4592 3.75 15.625 3.75C15.7908 3.75 15.9497 3.81585 16.0669 3.93306C16.1842 4.05027 16.25 4.20924 16.25 4.375V6.25Z"
      fill={props.stroke}
    />
    <path
      d="M3.125 18.125C3.125 18.2908 3.19085 18.4497 3.30806 18.5669C3.42527 18.6842 3.58424 18.75 3.75 18.75H7.5C7.66576 18.75 7.82473 18.6842 7.94194 18.5669C8.05915 18.4497 8.125 18.2908 8.125 18.125V17.5H3.125V18.125Z"
      fill={props.stroke}
    />
    <path
      d="M11.875 18.125C11.875 18.2908 11.9408 18.4497 12.0581 18.5669C12.1753 18.6842 12.3342 18.75 12.5 18.75H16.25C16.4158 18.75 16.5747 18.6842 16.6919 18.5669C16.8092 18.4497 16.875 18.2908 16.875 18.125V17.5H11.875V18.125Z"
      fill={props.stroke}
    />
  </svg>
);
